// extracted by mini-css-extract-plugin
export default {"body":"AdminProfile_body__P6dyQ","stats":"AdminProfile_stats__A2Vhs","optsCont":"AdminProfile_optsCont__tJZEM","danger":"AdminProfile_danger__NcObJ"};